var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useEffect, useState } from 'react';
import { UnitConversion } from '../../../utils/Measurement/UnitConversion';
import './SelectBox.scss';
import { SelectComponent } from './SelectComponent';
import { jsx as _jsx } from "react/jsx-runtime";
export var SelectBox = function (props) {
    var id = props.id, label = props.label, _a = props.disabled, disabled = _a === void 0 ? false : _a, _b = props.required, required = _b === void 0 ? false : _b, _c = props.isError, isError = _c === void 0 ? false : _c, options = props.options, measurementAttr = props.measurementAttr, imperialUnit = props.imperialUnit, measurementTypeId = props.measurementTypeId, hasAllowedValues = props.hasAllowedValues, select = props.select, unSelect = props.unSelect, className = props.className, other = __rest(props, ["id", "label", "disabled", "required", "isError", "options", "measurementAttr", "imperialUnit", "measurementTypeId", "hasAllowedValues", "select", "unSelect", "className"]);
    var _d = useState(''), displayValue = _d[0], setDisplayValue = _d[1];
    var _e = useState(false), selectDisable = _e[0], setSelectDisable = _e[1];
    var getDisplayValue = function (value) { if (measurementAttr) {
        if (imperialUnit && measurementTypeId && measurementTypeId > 0) {
            return UnitConversion.convertMetricToImperial(parseFloat(value), measurementTypeId);
        }
        else
            return parseFloat(value).toFixed(4);
    } return value; };
    var optionArray = []; // mapping to send only relevant info to SelectComponent
    var mapOptions = function (options) { options.forEach(function (optionValue) { optionArray.push({ value: optionValue.value, name: getDisplayValue(optionValue.name), incompatible: optionValue.incompatible }); }); return optionArray; }; // helper function to pass callback function from select
    var setCallback = function (value) { if (id) {
        if (value != '')
            select(id, value);
        else
            unSelect && unSelect(id);
    } };
    var defaultValue;
    useEffect(function () { var _defaultValue; defaultValue = options.find(function (option) { return option.assigned; }); setDisplayValue(defaultValue && defaultValue.value ? defaultValue.value.toString() : 'Select'); if ((_defaultValue = defaultValue) !== null && _defaultValue !== void 0 && _defaultValue.assigned) {
        setSelectDisable(defaultValue.value != undefined && defaultValue.assigned === 'byRule');
    }
    else
        setSelectDisable(false); });
    return /*#__PURE__*/ _jsx(SelectComponent, { className: className, id: id, label: label, options: mapOptions(options), value: displayValue, setValue: setCallback, required: required, selectDisable: selectDisable, disabled: disabled, isError: isError });
};
